export const state = () => ({
  langList: [
    'ar', // 阿拉伯语
    'de', // 德语
    'en',
    'es',
    'fil',
    'fr', // 法语
    'hi', // 印地
    'id',
    'it', // 意大利
    'ja',
    'ko', // 韩语
    'pt', // 葡萄牙语
    'tr', // 土耳其
    'ru',
    'th',
    'vi',
    'zh',
    'zh-cn',
    'zh-hk',
    'zh-tw'
  ], // 国际版语言列表
  myCountry: '', // 用户所在的国家（不变的值）
  host: '', // 获取域名
  allHost: '', // 当前页面地址
  path: '', // 当前页面路径（不包含语言）
  LanguageCode: '', // 语言
  CountryCode: '', // 国家
  getCountry: {}, // 获取国家code，国家名称，国家代码，国旗
  cookieHost: '', // 处理好存cookie需要的路径域名
  userIp: '', // 用户ip
  mobile: false, // 是否为移动端pc---false；m站---true
  contentcookie: '', // 用户登录cookie值
  user: {}, // 用户登录信息userId--用户id；nick用户昵称；avatar--用户头像;vest为true为马甲号
  userInfo: {}, // 用户信息3083183482-9773081902-1024144787-0139468511
  usergetCountry: {}, // 用户中心国家数据
  riskShow: false, // 风险提示是否展示
  menuData: [], // 菜单数据
  contactinfo: '', // 底部联系方式
  indexConfigure: [], // 首页配置
  footCountry: [], // 底部国家
  loginShow: false, // 登录框是否显示
  pluginShow: false, // chrome下载框是否显示
  linkFriend: [], // 友情链接
  partnerList: [], // 战略合作
  newhost: 'wikifx', // 特殊域名--保留主体部分
  newsbool: false, // 是否为特殊域名
  loghost: 'http://192.168.200.151:8087', // 日志请求地址 1
  isWiki: '1', // (1:wikifx;2:包含普通fxeye；3:包含wikifxvn.com,wikifxvi.com,wikifxen.com, 4:fxeye中推广用的特殊域名)
  fxeyepoint: {}, // fxeye点位配置
  livestate: {}, // 直播状态 1-进行中；2-未开始；3-已结束
  curProvince: '', // 省份
  curCity: '', // 城市
  useragent: '', // 请求代理header['user-agent']
  bfp: '', // 指纹
  navList: [], // 菜单导航所有数据
  visibleList: [], // 菜单导航可见区域的菜单项
  invisibleList: [], // 菜单导航不可见区域的菜单项
  langshow: false, // 语言切换是否显示源码
  linkDom: '', // 页面底部外链dom
  oneText: '', // 首页交易商数量--小屏幕
  twoText: '', // 首页监管国家数量--小屏幕
  longoneText: '', // 首页交易商数量--大屏幕
  longtwoText: '', // 首页监管国家数量--大屏幕
  articleCate: [], // 首页排行榜右侧文章tab
  protectionresult: [], // 首页调节中心数据
  adshow: false, // 底部广告是否显示
  nodeEnv: '', // 环境变量
  isIe: false, // 是否为ie浏览器，false其他浏览器；true为ie浏览器
  adallshow: true, // 香港所有广告为是否显示
  shshow: true, // 上海地区是否屏蔽显示true不屏蔽默认显示，false隐藏
  nonCooperativeTraders: [], // 交易商详情页底部推荐交易商,
  brokerwikifxarr: [], // 底部推荐stock
  bottomH: '0px', // 页面底部间距
  addcommentarr: {}, // 评论新增一条临时数据
  riskcontrol: {}, // 屏蔽点位
  testdata: {},
  articleData: [],
  homeactive: 'article_0',
  homeurl: '/news.html',
  wordid: '', // 是否存在文字版交易商
  lcsdata: {}, // lcs关联数据
  cardList: [], // 名片list
  nestinghref: '', // 套嵌登录框域名
  userlogin2: false, // 登录框是否为页面套用
  traderclaim: 1, // 交易商详情页展示加入/认领-1；合作2
  islangsw: false, // 是否展示语言切换
  nowtime: 0,
  dealercount: 1,
  apptitle: '', // app显示title
  tipsheight: 0, // 首页提示高度
  headshow: false, // 头部显示
  screenSize: 'xl', // '1199以上:xl; 999以上:lg 800以上:md,799以下:sm'
  suffix: 'com',
  apphead: {}, // app传过来的头部信息
  serverbfp: '', // 服务端生成的唯一指纹
  loginverify: false // 登录状态401时为true
})

export const mutations = {
  loginverifyfn(state, value) {
    state.loginverify = value
  },
  serverbfpfn(state, value) {
    state.serverbfp = value
  },
  setapphead(state, value) {
    state.apphead = value
  },
  setsuffix(state, value) {
    // 设置域名后缀
    state.suffix = value
  },
  setScreenSize(state, value) {
    // 设置尺寸
    state.screenSize = value
  },
  setheadshow(state, value) {
    state.headshow = value
  },
  settipsheight(state, value) {
    state.tipsheight = value
  },
  setapptitle(state, value) {
    state.apptitle = value
  },
  setdealercount(state, value) {
    state.dealercount = value
  },
  setnowtime(state, value) {
    state.nowtime = new Date().getTime()
  },
  setlangsw(state, value) {
    state.islangsw = value
  },
  settraderclaim(state, value) {
    state.traderclaim = value
  },
  setnestinghref(state, value) {
    state.nestinghref = value
  },
  setuserlogin2(state, bel) {
    // 修改userlogin
    console.log('setuserlogin2', bel)
    state.userlogin2 = bel
  },
  set_cardList(state, arr) {
    // 传入名片list
    state.cardList = arr
  },
  setlcsdata(state, value) {
    Object.assign(state.lcsdata, value)
  },
  setwordid(state, value) {
    state.wordid = value
  },
  sethome(state, value) {
    state.homeactive = value.active
    state.homeurl = value.url
  },
  setarticleData(state, value) {
    state.articleData = [...value]
  },
  settestdata(state, value) {
    state.testdata = value
  },
  setriskcontrol(state, value) {
    // 设置屏蔽点位
    Object.assign(state.riskcontrol, value)
  },
  setaddcommentarr(state, value) {
    state.addcommentarr = value
  },
  setbottomH(state, value) {
    // 设置页面底部
    state.bottomH = value
  },
  setshshow(state, value) {
    state.shshow = value
  },
  setadallshow(state, value) {
    state.adallshow = value
  },
  setnonCooperativeTraders(state, value) {
    state.nonCooperativeTraders = [...value]
  },
  setbrokerwikifx(state, value) {
    state.brokerwikifxarr = [...value]
  },
  setisie(state, value) {
    // 设置是否为ie
    state.isIe = value
  },
  setNodeEnv(state, value) {
    // 获取环境变量
    state.nodeEnv = value || ''
    this.$cookies.set('nodeEnv', state.nodeEnv, {
      path: '/',
      domain: state.cookieHost
    })
  },
  setadshow(state, value) {
    // 设置底部广告是否显示
    state.adshow = value
  },
  setprotectionresult(state, value) {
    // 设置首页调节中心数据
    state.protectionresult = [...value]
  },
  setarticleCate(state, value) {
    // 设置首页排行榜右侧文章tab
    state.articleCate = [...value]
  },
  setoneText(state, value) {
    // 设置首页交易商数量--小屏幕
    state.oneText = value
  },
  settwoText(state, value) {
    // 首页监管国家数量--小屏幕
    state.twoText = value
  },
  setlongoneText(state, value) {
    // 设置首页交易商数量--大屏幕
    state.longoneText = value
  },
  setlongtwoText(state, value) {
    // 首页监管国家数量--大屏幕
    state.longtwoText = value
  },
  setnavList(state, value) {
    // 设置菜单
    state.navList = [...value]
  },
  setvisibleList(state, value) {
    // 设置菜单导航可见区域的菜单项
    state.visibleList = [...value]
  },
  setinvisibleList(state, value) {
    // 设置菜单导航不可见区域的菜单项
    state.invisibleList = [...value]
  },
  setlangshow(state, value) {
    // 设置语言切换是否显示源码
    state.langshow = value
  },
  setlinkDom(state, value) {
    // 设置页面底部外链dom
    state.linkDom = value
  },
  setLivestate(state, value) {
    // 获取直播状态
    // state.livestate = value
    Object.assign(state.livestate, value)
  },
  setFxeyepoint(state, value) {
    // 设置fxeye点位配置
    Object.assign(state.fxeyepoint, value)
  },
  setHost(state, value) {
    // 处理特殊域名
    state.newhost = value.host
    state.newsbool = value.bool
  },
  setlinkFriend(state, value) {
    // 友情链接
    state.linkFriend = [...value]
  },
  setPartnerList(state, value) {
    // 战略合作
    state.partnerList = [...value]
  },
  setPluginShow(state, value) {
    // 更新chrome下载框显示状态
    state.pluginShow = value
  },
  loginClose(state, value) {
    // 切换登录框显示状态
    state.loginShow = value
  },
  setfootCountry(state, value) {
    // 设置底部国家
    state.footCountry = [...value]
  },
  setcookieHost(state, value) {
    // 处理好存cookie需要的路径域名.wikifxen.com
    const host1 = ['fxeye688.com', 'fxeye.com', 'fxeyevn.com', 'fxeyevi.com', 'fxeye555.com', 'fxeye2021.com', 'fxeyefx.com', 'fxeyevps.com', 'wikifx.hk'] // 普通fxeye域名
    const host2 = [
      'wikifxtips.com',
      'wikifx25.com',
      'fxeye25.com',
      'fxeyevip.com',
      'fxeyetips.com',
      'fxeyema.com',
      'fxeyeka.com',
      'fxeyecn.com',
      'wikifxvn.com',
      'wikifxvi.com',
      'wikifxen.com',
      'wikifxzh.com',
      'wikifxka.com',
      'wikifxcn.com'
    ] // 特殊wikifx域名
    const host3 = ['fxeye110.com', 'fxeye123.com', 'fxeye777.com'] // 特殊fxeye域名[推广]
    const host4 = ['wikifx.com', 'fxeye2017.com', 'wikifx2.com', 'www.shareowen.com', 'www.mchgi.com'] //  wikifx域名
    state.cookieHost = value
    // value = 'www.wikifx.com'
    let urlBool = ''
    if (!value.includes('.') || value.includes('localhost') || value.includes('127.0.0.1') || value.includes('192.168.1.')) {
      urlBool = value
    } else if (value.split('.').length <= 2) {
      // value.split('.')[0] + '.' + value.split('.')[1]
      urlBool = value.split('.')[1]
    } else if (value.split('.').length >= 3) {
      if (value.includes('.com.cn')) {
        urlBool = value.split('.')[1] + '.' + value.split('.')[2] + '.' + value.split('.')[3]
      } else {
        urlBool = value.split('.')[1] + '.' + value.split('.')[2]
      }
    }
    if (host4.includes(urlBool)) {
      state.isWiki = '1'
    }
    if (host1.includes(urlBool)) {
      // 包含fxeye
      state.isWiki = '2'
    }
    if (host2.includes(urlBool)) {
      // wikifxvn.com,wikifxvi.com,wikifxen.com
      state.isWiki = '3'
    }
    if (host3.includes(urlBool)) {
      // 是否是特殊的fxeye域名
      state.isWiki = '4'
    }
    this.$cookies.set('isWiki', state.isWiki, {
      path: '/',
      domain: state.cookieHost
    })
  },
  setConfigure(state, value) {
    // 首页配置
    state.indexConfigure = [...value]
  },
  setContactinfo(state, value) {
    // 底部联系方式
    state.contactinfo = value
  },
  setMenu(state, value) {
    // 设置菜单数据
    state.menuData = [...value]
  },
  setUCookie(state, value) {
    // 存储用户信息
    state.cookieVal = value
  },
  setUserInfo(state, value) {
    // 存储用户信息
    state.userInfo = value
  },
  setRisk(state, value) {
    // 设置风险提示
    state.riskShow = value
  },
  setPath(state, value) {
    // 设置当前页面路径（不包含语言）
    state.path = value
  },
  setUser(state, value) {
    // 设置用户信息
    this.$cookies.set('userid', value && value.userId, {
      path: '/',
      domain: state.cookieHost
    })
    state.user = Object.assign({}, value)
  },
  setuserCountry(state, value) {
    // 用户中心国家数据
    state.usergetCountry = Object.assign({}, value)
  },
  setUsercookie(state, value) {
    // 获取用户登录cookie
    state.contentcookie = value
  },
  setMobile(state, value) {
    // 设置移动端还是pc端
    state.mobile = value
  },
  setInfo(state, value) {
    // 获取国家code，国家名称，国家代码，国旗
    state.getCountry = Object.assign({}, value)
  },
  getIp(state, value) {
    // 获取用户ip
    state.userIp = value
  },
  getmyProvince(state, value) {
    // 省份
    state.curProvince = value
  },
  getmyCity(state, value) {
    // 城市
    state.curCity = value
  },
  getuserAgent(state, value) {
    // 请求头代理
    state.useragent = value
  },
  getbfp(state, value) {
    // 指纹
    state.bfp = value
  },
  setHostend(state, value) {
    // 设置域名后缀
    state.host = value
  },
  setAllhost(state, value) {
    // 获取当前页面地址
    state.allHost = value.replace(':443', '')
  },
  // 存储用户所在的国家
  setMyCountry(state, value) {
    if (!value.myCountry) return false
    state.myCountry = value.myCountry?.toLowerCase()
    this.$cookies.set('CURRIPCOUNTRY', value.myCountry?.toLowerCase(), {
      path: '/',
      domain: state.cookieHost
    })
  },
  // 存储交易商详情页origin--cookie
  setorigin(state, value) {
    this.$cookies.set('origin', value, { path: '/', domain: state.cookieHost })
  },
  // 设置语言code
  setLangCode(state, value) {
    const lang = value.lang ? value.lang.toLowerCase() : ''
    state.LanguageCode = state.langList.includes(lang) ? lang : 'en'
    this.$cookies.set('LanguageCode', state.LanguageCode, {
      path: '/',
      domain: state.cookieHost
    })
  },
  // 设置国家code
  setCountryCode(state, value) {
    state.CountryCode = value.country && value.country.toLowerCase()
    this.$cookies.set('CountryCode', value.country && value.country.toLowerCase(), { path: '/', domain: state.cookieHost })
  },
  setVest(state, value) {
    // 切换马甲时设置原账号cookie
    this.$cookies.set('VEST', value, { path: '/', domain: state.cookieHost })
  }
}

export const actions = {
  nuxtServerInit({ commit }, { req }) {
    if (!req.headers || !req.headers?.cookie) return false // 若没有cookie时，不执行后续操作
    const [myCook] = [this.$cookies.get('DJkdikKMG') || this.$cookies.get('ViLartidlakd') || this.$cookies.get('WsdsfgDGdagYms') || '']
    commit('setUsercookie', myCook)
  }
}

export const modules = {}
